import { useState, useEffect } from 'react';

const useContainerSize = () => {
  const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const updateSize = () => {
      const headerHeight = 60; // Approximate height of meeting info bar
      const controlsHeight = 80; // Approximate height of bottom controls
      const contentHeight = window.innerHeight - headerHeight - controlsHeight;
      
      setContainerSize({
        width: window.innerWidth,
        height: contentHeight
      });
    };

    updateSize();
    window.addEventListener('resize', updateSize);
    
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return containerSize;
};

export default useContainerSize;

